import { Component, inject } from '@angular/core';
import { Dialog } from '../dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { DialogComponent } from '../dialog/dialog.component';
import { OperatorMappingId } from '@web/dtos';
import { ButtonComponent } from '../../feedback/button/button.component';
import { TemplateStringPipe } from '../../../pipes/template-string/TemplateStringPipe.pipe';

@Component({
  selector: 'aw-edit-operator-mapping-dialog',
  imports: [
    DialogComponent,
    ReactiveFormsModule,
    ButtonComponent,
    TemplateStringPipe,
  ],
  templateUrl: './delete-operator-mapping-dialog.component.html',
})
export class DeleteOperatorMappingDialog extends Dialog<{
  operatorMappingId: OperatorMappingId | null;
  operatorName: string | null;
  index: number;
}> {
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );

  constructor() {
    super();
  }
}
